<template>
<div style = "align-items: center; text-align: center;">

  <iframe width="640px" height= "480px" src="https://forms.gle/fFZfQsiQz5AmwGrq8" frameborder= "0" marginwidth= "0" marginheight= "0" style= "border: none; max-width:100%; max-height:100vh" allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen></iframe>
  <!-- <iframe width="640px" height= "480px" src= "https://forms.office.com/Pages/ResponsePage.aspx?id=Yg4JVkAlB0GRb82WkPQj09Yimbhi47FMveK0kwk1O4xUQk9LM0M2U0lWN1JOTkZSTTNTN0JJWDM5Ri4u&embed=true" frameborder= "0" marginwidth= "0" marginheight= "0" style= "border: none; max-width:100%; max-height:100vh" allowfullscreen="" webkitallowfullscreen="" mozallowfullscreen="" msallowfullscreen=""> </iframe> -->
  <p>Please log in to your obf account to access. If the form above does not work, apply through <a href="https://forms.gle/fFZfQsiQz5AmwGrq8" style="font-size:medium">this link.</a> </p>
  <!-- <p> Microsoft Forms is currently undergoing maintenance. It will shortly be up and running soon. Thank you!</p> -->

</div>
</template>

<script>
  import * as typeformEmbed from '@typeform/embed'
  // import VModal from 'vue-js-modal'
  export default {
    name: 'Apply',
    // props: {
    //   msg: String
    // }
    methods: {
    },
    mounted(){
          const popupApp = typeformEmbed.makePopup(
              'https://erinyabut.typeform.com/to/AbK9phcu',
                {        
                  hideHeaders: true,
                  hideFooter: true,
                  onSubmit: function () {
                    console.log('Application form successfully submitted')
                  },
                  onReady: function () {
                    console.log('Application form is ready')
                  }
                }
              )
      document.getElementById('bt-popup').addEventListener('click', function () {
        popupApp.open();
      });
      this.showModal();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  button{
    padding: 0.40vw;
    font-size: 1.75vw;
    width: 14.34vw;
    margin-left: 19.76vw;
    position: relative;
    margin-bottom: 80px;
  }
  #bg{
    top:0;
    left:0;
    bottom:0;
    right:0;
    margin-bottom: 40px;
  }
  #bg .img{
    position: absolute;
    background-position: 
      top 10vw left 0vw,
      bottom 0vw left 83.8vw;
      
    background-image: 
    url('~@/assets/blob2.png'),
    url('~@/assets/blob1.png');
    
    width: 100%;
    height:50.5vw;
    background-size:15vw;
    background-repeat: no-repeat;
    /* overflow: auto; */
  }

  @media only screen and (max-width: 1353px) {
      .img{
          display: none;
      }
    }

  h1{
    margin-top: 64px;
    margin-left: 18.30vw;
    margin-right: 16vw;
    max-width: 840px;
  }
  h4, h5{
    margin-left: 19.76vw;
    margin-right: 16vw;
    font-weight: lighter;
    max-width: 840px;
  }
</style>
